import { colors, radius, elevation, spacing, glassEffect } from '../../utils/designSystem';

export function Card({
  children,
  className = "",
  style = {},
  variant = "default",
  padding = "md",
  elevation: elevationLevel = "md"
}) {
  // Padding variants
  const paddings = {
    none: spacing[0],
    sm: spacing[3],
    md: spacing[5],
    lg: spacing[6],
  };

  // Variant styles using design system
  const variants = {
    default: {
      background: colors.neutral.white,
      border: `1px solid ${colors.neutral[200]}`,
      boxShadow: elevation[elevationLevel],
    },
    glass: {
      ...glassEffect(0.8),
      boxShadow: elevation.lg,
    },
    elevated: {
      background: colors.neutral.white,
      border: 'none',
      boxShadow: elevation.xl,
    },
    flat: {
      background: colors.neutral.white,
      border: `1px solid ${colors.neutral[200]}`,
      boxShadow: elevation.none,
    },
    subtle: {
      background: colors.neutral[50],
      border: `1px solid ${colors.neutral[100]}`,
      boxShadow: elevation.sm,
    },
  };

  const currentVariant = variants[variant] || variants.default;
  const currentPadding = paddings[padding] || paddings.md;

  const cardStyle = {
    borderRadius: radius.card,
    padding: currentPadding,
    background: currentVariant.background,
    backdropFilter: currentVariant.backdropFilter,
    WebkitBackdropFilter: currentVariant.backdropFilter,
    border: currentVariant.border,
    boxShadow: currentVariant.boxShadow,
    ...style,
  };

  return (
    <div className={`transition-shadow duration-250 ${className}`} style={cardStyle}>
      {children}
    </div>
  );
}
